import { Box, Button, CardMedia, Grid, Typography } from '@mui/material';
import React from 'react';
import './UseCase.css';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { NavLink } from 'react-router-dom';

const UseCase = () => {
    const [allCases, setAllCases] = React.useState(false);
    const [useCase, setUseCase] = React.useState([]);

    React.useEffect(() => {
        fetch(`./usecase.json`)
            .then(res => res.json())
            .then(data => setUseCase(data));
    }, [])
    const firstUseCase = useCase.slice(0, 2)
    const secondUseCase = useCase.slice(2, 4)
    const thirdUseCase = useCase.slice(4, 14)
    const fourthUseCase = useCase.slice(14, 24)

    React.useEffect(() => {
        Aos.init({ duration: 500 });
    }, []);

    return (
        <>
            <Box sx={{ mx: { xs: 1.2, sm: 3.5, md: 6, lg: 9, xl: 28 } }}>
                <Box sx={{ my: { xs: '10px', sm: '25px' }, pb: { lg: '15px' } }}>
                    <CardMedia
                        component="img"
                        image="https://i.ibb.co/vsSJ8XV/use-case.png"
                        alt="Use Case"
                    />
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', py: '20px' }}>
                    <Box className="first-box" sx={{ height: { xs: '30px', sm: '40px', md: '50px', lg: '61px' }, width: { xs: '9px', sm: '12px', md: '15px', lg: '21px' }, background: '#4741E4' }}></Box>
                    <Box className="second-box" sx={{ height: { xs: '30px', sm: '40px', md: '50px', lg: '61px' }, width: { xs: '9px', sm: '12px', md: '15px', lg: '21px' }, background: '#7E89FF' }}></Box>
                    <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: { xs: '20px', sm: '22px', md: '25px', lg: '30px' }, lineHeight: { xs: '30px', lg: '45px' }, color: { xs: '#433ED1', sm: '#383838' }, textAlign: 'left', pl: { xs: '18px', sm: '22px', md: '28px', lg: '36px' } }}>
                        Use Cases
                    </Typography>
                </Box>

                <Box sx={{ pt: '10px', pb: { xs: '50px', sm: '55px', md: '75px', xl: '106px' }, pl: { xl: '70px' }, pr: { xl: '70px' } }}>
                    <Box sx={{ display: { sm: 'flex' } }}>
                        {/* top left boxes */}
                        <Box>
                            <Grid container>
                                {firstUseCase.map(Case =>
                                    <Grid item xs={12} key={Case.id} sx={{ m: { xs: '16px', sm: '17px', md: '22px', lg: '30px', xl: '35px' } }} data-aos="fade-up">
                                        <NavLink to={`${Case.id}`} style={{ textDecoration: 'none' }}>
                                            <Box className="case-image">
                                                <CardMedia
                                                    component="img"
                                                    image={Case.img}
                                                    alt="img"
                                                />
                                                <Typography className="case-name" sx={{ fontFamily: 'poppins', fontWeight: 600, fontSize: { xs: '16px', md: '22px', xl: '36px' }, lineHeight: { xs: '38px', sm: '46px', md: '55px', xl: '70px' }, textAlign: 'left', color: '#FFFFFF', pl: '15px' }}>{Case.title}</Typography>
                                            </Box>
                                        </NavLink>
                                    </Grid>
                                )}
                            </Grid>
                        </Box>
                        {/* top right boxes */}
                        <Box sx={{ mt: { sm: '25px', lg: '35px' } }}>
                            <Grid container>
                                {secondUseCase.map(Case =>
                                    <Grid item xs={12} key={Case.id} sx={{ m: { xs: '16px', sm: '17px', md: '22px', lg: '30px', xl: '35px' } }} data-aos="fade-down"><NavLink to={`${Case.id}`} style={{ textDecoration: 'none' }}>
                                        <Box className="case-image">
                                            <CardMedia
                                                component="img"
                                                image={Case.img}
                                                alt="img"
                                            />
                                            <Typography className="case-name" sx={{ fontFamily: 'poppins', fontWeight: 600, fontSize: { xs: '16px', md: '22px', xl: '36px' }, lineHeight: { xs: '38px', sm: '46px', md: '55px', xl: '70px' }, textAlign: 'left', color: '#FFFFFF', pl: '15px' }}>{Case.title}</Typography>
                                        </Box>
                                    </NavLink>
                                    </Grid>
                                )}
                            </Grid>
                        </Box>
                    </Box>

                    {allCases === true ?
                        // after collapse
                        <>
                            <Button onClick={() => setAllCases(false)} sx={{ textDecoration: 'none', fontSize: { sm: '11px', md: '14px', lg: '16px' }, lineHeight: '20px', color: "#FFFFFF", px: '32px', py: '8px', backgroundImage: 'linear-gradient(90deg, #322DC3 0%, #5968FE 100%)', boxShadow: '0px 1.47268px 5.89072px rgba(186, 192, 255, 0.57)', fontFamily: 'poppins', fontWeight: 600, borderRadius: '0.73634px', mt: { xs: '25px', md: '40px' } }} style={{ textTransform: 'capitalize' }}>
                                View All Cases
                            </Button>

                            <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: { xs: '10px', sm: '13px', md: '16px', xl: '19px' }, lineHeight: { xs: '15px', sm: '20px', md: '24px', xl: '26px' }, textAlign: 'center', color: '#535353', pt: '15px' }}>After Collapse</Typography>
                            <Typography sx={{ fontWeight: 500, fontSize: { xs: '10px', sm: '13px', md: '16px', xl: '19px' }, textAlign: 'center', color: '#535353', pb: { xs: '20px', md: '30px' } }}>
                                <i className='fas fa-long-arrow-alt-down'></i>
                            </Typography>


                            <Box sx={{ display: { sm: 'flex' } }}>
                                {/* left boxes */}
                                <Box>
                                    <Grid container>
                                        {thirdUseCase.map(Case =>
                                            <Grid item xs={12} key={Case.id} sx={{ m: { xs: '16px', sm: '17px', md: '22px', lg: '30px', xl: '35px' } }} data-aos="fade-up">
                                                <NavLink to={`${Case.id}`} style={{ textDecoration: 'none' }}>
                                                    <Box className="case-image">
                                                        <CardMedia
                                                            component="img"
                                                            image={Case.img}
                                                            alt="img"
                                                        />
                                                        <Typography className="case-name" sx={{ fontFamily: 'poppins', fontWeight: 600, fontSize: { xs: '16px', md: '22px', xl: '36px' }, lineHeight: { xs: '38px', sm: '46px', md: '55px', xl: '70px' }, textAlign: 'left', color: '#FFFFFF', pl: '15px' }}>{Case.title}</Typography>
                                                    </Box>
                                                </NavLink>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Box>
                                {/* right boxes */}
                                <Box sx={{ mt: { sm: '25px', lg: '35px' } }}>
                                    <Grid container>
                                        {fourthUseCase.map(Case =>
                                            <Grid item xs={12} key={Case.id} sx={{ m: { xs: '16px', sm: '17px', md: '22px', lg: '30px', xl: '35px' } }} data-aos="fade-down">
                                                <NavLink to={`${Case.id}`} style={{ textDecoration: 'none' }}>
                                                    <Box className="case-image">
                                                        <CardMedia
                                                            component="img"
                                                            image={Case.img}
                                                            alt="img"
                                                        />
                                                        <Typography className="case-name" sx={{ fontFamily: 'poppins', fontWeight: 600, fontSize: { xs: '16px', md: '22px', xl: '36px' }, lineHeight: { xs: '38px', sm: '46px', md: '55px', xl: '70px' }, textAlign: 'left', color: '#FFFFFF', pl: '15px' }}>{Case.title}</Typography>
                                                    </Box>
                                                </NavLink>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Box>
                            </Box>
                        </>
                        :
                        // before collapse
                        <Button onClick={() => setAllCases(true)} sx={{ textDecoration: 'none', fontSize: { sm: '11px', md: '14px', lg: '16px' }, lineHeight: '20px', color: "#FFFFFF", px: '32px', py: '8px', backgroundImage: 'linear-gradient(90deg, #322DC3 0%, #5968FE 100%)', boxShadow: '0px 1.47268px 5.89072px rgba(186, 192, 255, 0.57)', fontFamily: 'poppins', fontWeight: 600, borderRadius: '0.73634px', mt: { xs: '25px', md: '40px' } }} style={{ textTransform: 'capitalize' }}>
                            View All Cases
                        </Button>
                    }
                </Box>
            </Box>
        </>
    );
};

export default UseCase;